import script from "./BaseTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTooltip.vue?vue&type=script&setup=true&lang=js"

import "./BaseTooltip.vue?vue&type=style&index=0&id=20d5742f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20d5742f"]])

export default __exports__